import React from 'react';

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table';

type RowObj = {
  key: string;
  value: string;
};

const columnHelper = createColumnHelper<RowObj>();
const columns = [
  columnHelper.accessor('key', {
    id: 'key',
    header: () => (
      <p className="text-lg font-bold text-gray-600 dark:text-white ">key</p>
    ),
    cell: (info) => (
      <p className="text-lg font-medium text-navy-700 dark:text-white ">
        {info.getValue()}
      </p>
    ),
  }),
  columnHelper.accessor('value', {
    id: 'value',
    header: () => (
      <p className="text-lg font-bold text-gray-600 dark:text-white ">Value</p>
    ),
    cell: (info) => (
      <p className="text-lg  text-navy-700 dark:text-white ">
        {info.getValue() || '-'}
      </p>
    ),
  }),
];

interface IProps {
  data: { key: string; value: string }[];
  header?: string;
  extraClasses?: string;
}
const SimpleTable: React.FC<IProps> = ({ data, header, extraClasses }) => {
  const table = useReactTable({
    data,
    columns,
    state: {},
    getCoreRowModel: getCoreRowModel(),
    debugTable: true,
  });
  return (
    <div
      className={`my-3 overflow-x-scroll p-4 xl:overflow-x-hidden ${extraClasses} `}
    >
      {header && (
        <div className="relative flex items-center justify-between pt-4">
          <div className="text-xl font-bold text-navy-700 dark:text-white">
            {header}
          </div>
        </div>
      )}
      <table className="w-full">
        <tbody>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr key={row.id} className="">
                {row.getVisibleCells().map((cell, index) => {
                  const columnWidthClass = index === 0 ? 'w-[30%]' : '';
                  return (
                    <td
                      key={cell.id}
                      className={`min-w-[150px] border-white/0 py-3  pr-4 ${columnWidthClass}`}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default SimpleTable;
